
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {}
  },
  methods: {
    handleClose() {
      this.$emit("close")
    }
  }
}
